import React from "react";

const TermofUse = () => {
  return (
    <>
      <div>
        <section className="bg-gray-100/50 py-20 lg:py-28 max-md:pt-[120px]">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

            {/* Section Header */}
            <div className="text-center">

              {/* Badge */}
              <div className="inline-flex items-center gap-2 rounded-full border border-[#1AAD9D50] bg-[#F4FFFE] px-4 py-2"  data-aos="fade-down">
                <span className="relative flex h-2 w-2">

                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#1AAD9D] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#1AAD9D]" />
                </span>
                <span className="text-sm font-medium text-[#1AAD9D]">
                  User Agreement
                </span>
              </div>
              <h2 className="mt-4 font-display text-3xl font-bold text-gray-900 lg:text-4xl"  data-aos="fade-up" data-aos-delay={100}>
                Terms & Policies
              </h2>
            </div>

            <div className="theme-container mx-auto mt-[40px]" data-aos="fade-up" data-aos-delay={200}>
              <div className="w-full">
                <div className="container">
                  <div className="services-details-items">
                    <div className="row">
                      <div className="col-xl-12 services-single-content">
                        <>
                          <p className="mb-[10px]">
                            These Terms &amp; Conditions (“terms”) Govern Your Access To And
                            Use Of The Saayaa Health Wellness Services Private Limited Website (the “website”) And The
                            Saas-based Healthtech Infrastructure We Provide (the “service”).
                            By Accessing Or Using The Website Or Service, You Agree To Be
                            Bound By These Terms.
                          </p>
                          <p className="mb-[10px]">
                            <strong>1. Definitions</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              <strong>"OPD Cover"</strong> Refers To Saayaa Health Wellness Services Private Limited, The Provider Of The Service.
                            </p>
                            <p className="mb-[10px]">
                              <strong>“You”</strong> Refers To The Individual Or Entity Accessing Or Using The Website Or Service.
                            </p>
                            <p className="mb-[10px]">
                              <strong>“Content”</strong> Refers To Any Information, Data, Text, Software, Code, Or Other Materials Displayed On Or Available Through The Website Or Service.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>2. Use of the Website and Service</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              You May Only Use The Website And Service For Lawful Purposes And In Accordance With These Terms.
                            </p>
                            <p className="mb-[10px]">You Agree Not To Use The Website Or Service:</p>
                            <div style={{ paddingLeft: 10 }}>
                              <p className="mb-[10px]">
                                • In A Manner That Could Damage, Disable, Overburden, Or Impair The Website Or Service.
                              </p>
                              <p className="mb-[10px]">
                                • To Interfere With Any Other User’s Enjoyment Of The Website Or Service.
                              </p>
                              <p className="mb-[10px]">
                                • To Gain Unauthorized Access To The Website Or Service, Or Any Computer Systems Or Networks Connected To The Website Or Service.
                              </p>
                              <p className="mb-[10px]">
                                • To Upload, Transmit, Or Store Any Content That Is Unlawful, Harassing, Defamatory, Obscene, Or Otherwise Objectionable.
                              </p>
                              <p className="mb-[10px]">• To Violate Any Applicable Laws Or Regulations.</p>
                            </div>
                          </div>
                          <p className="mb-[10px]">
                            <strong>3. User Content</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              You Are Solely Responsible For Any Content You Upload, Transmit, Or Store On The Website Or Service.
                            </p>
                            <p className="mb-[10px]">
                              You Grant Saayaa Health Wellness Services Private Limited&nbsp; Company Grants A Non-exclusive,
                              Royalty-free License To Use, Reproduce, Modify, Publish, And
                              Distribute Your User Content In Connection With The Website
                              And Service.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>4. Intellectual Property</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              The Website And Service, Including All Content, Are Protected
                              By Copyright, Trademark, And Other Intellectual Property Laws.
                            </p>
                            <p className="mb-[10px]">
                              You Agree Not To Remove, Alter, Or Obscure Any Copyright Notices Or Other Proprietary Notices Placed On The Website Or Service.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>5. Disclaimers</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              The Website And Service Are Provided “as Is” And Without Warranties Of Any Kind, Whether Express Or Implied. Saayaa Health Wellness Services Private Limited Disclaims All Warranties, Including, But Not Limited To, The Warranties Of Merchantability, Fitness For A Particular Purpose, And Non-infringement.
                            </p>
                            <p className="mb-[10px]">
                              Saayaa Health Wellness Services Private Limited Does Not Warrant That The Website Or Service Will Be Uninterrupted Or Error-free, That Defects Will Be Corrected, Or That The Website Or Service Is Free Of Viruses Or Other Harmful Components.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>6. Limitation of Liability</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              Saayaa Health Wellness Services Private Limited Shall Not Be Liable For Any Direct, Indirect, Incidental, Special, Consequential, Or Punitive Damages Arising Out Of Or In Connection With Your Use Of The Website Or Service.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>7. Term and Termination</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              These Terms Shall Remain In Full Force And Effect Until Terminated By You Or Saayaa Health Wellness Services Private Limited.
                            </p>
                            <p className="mb-[10px]">
                              Saayaa Health Wellness Services Private Limited May Terminate These Terms At Any Time, With Or Without Cause, Upon Written Notice To You.
                            </p>
                            <p className="mb-[10px]">
                              You May Terminate These Terms By Discontinuing Your Use Of The Website And Service.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>8. Governing Law</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              These Terms Are Governed By The Laws Of India. All Disputes Are Subject To The Exclusive Jurisdiction Of The Courts In Delhi.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>9. Entire Agreement</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              These Terms Constitute The Entire Agreement Between You And Saayaa Health Wellness Services Private Limited With Respect To The Use Of The Website And Service.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>10. Severability</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              If Any Provision Of These Terms Is Held To Be Invalid Or Unenforceable, Such Provision Shall Be Struck And The Remaining Provisions Shall Remain In Full Force And Effect.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>11. Waiver</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              No Waiver Of Any Provision Of These Terms Shall Be Deemed A Further Or Continuing Waiver Of Such Provision Or Any Other Provision.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>12. Update to Terms</strong>
                          </p>
                          <div>
                            <p className="mb-[10px]">
                              Saayaa Health Wellness Services Private Limited May Update These Terms At Any Time By Posting The <strong>Amended Terms</strong> On The Website. Your Continued Use Of The Website Or Service Following The Posting Of Amended Terms Constitutes Your Acceptance Of The Amended Terms.
                            </p>
                          </div>
                          <p className="mb-[10px]">
                            <strong>13. Contact Us</strong>
                          </p>
                          <p className="mb-[10px]">
                            If You Have Any Questions About These Terms, Please Contact Us At info@opdcover.com.
                          </p>
                          <p className="mb-[10px]">
                            <strong>14. For Group Insurance and Personal Accident Rider</strong>
                          </p>
                          <p className="mb-[10px]">
                            The eligible age for the primary policyholder shall be between 18 and 65 years.
                          </p>
                          <p className="mb-[10px]">
                            <strong>15. For OPD Wellness Benefits</strong>
                          </p>
                          <p className="mb-[40px]">
                            The eligible age shall be between 0 and 85 years.
                          </p>

                          <p className="text-[12px] text-right max-md:text-left"><i>Last Updated On: March 16, 2026</i></p>
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    </>

  );
};

export default TermofUse;
